export default __webpack_public_path__ + "static/media/5.6ad8df5f.jpg";